export enum StoreTypename {
  UI = 'Store.Ui',
  ACTIVE_LESSON = 'Store.ActiveLesson',
  USER = 'User',
  TOUR = 'TourSetting',
  RESOURCES = 'Resources',
  FAVORITE_RESOURCES = 'Favorite Resources',
  RESOURCE_FILTERS = 'Resource Filters',
  BOOK_CONTENT = 'Book Content',
  CUSTOM_TEACHING_ORDERS = 'Custom Teaching Orders',
  BOOK = 'Book',
}

export enum ButtonSize {
  XLARGE = 140,
  LARGE = 120,
  MEDIUM = 100,
  SMALL = 80,
  XSMALL = 70,
}

export enum TYPOGRAPHY_TYPES {
  ASCENDER = 'ascender',
  DESCENDER = 'descender',
  PLAIN = 'plain',
}

export enum SCREEN_RESIZE_MEDIA_QUERY {
  IPAD = '(max-width:1024px)',
  LAPTOP = '(min-width:1600px)',
  PORTRAIT = '(orientation: portrait)',
  MIN_HEIGHT = '@media (min-height:800px)',
}

export enum AppRoutes {
  HOME = 'home',
  LETTER_BOOK = 'letter-book',
  LETTER_BOOKS = 'letter-books',
  PRACTICE_BOOK = 'practice-book',
  TEACHERS_GUIDE = 'teachers-guide',
  RESOURCES = 'resources',
  STUDENT_PRACTICE_BOOK = 'student-practice-book',
  LETTER_TEACHING = 'letter-teaching',
  CLASSROOM_BOOKS = 'classroom-books',
  ACTIVITY_SELECTION = 'activity-selection',
  ACTIVITY_COMPLETE = 'activity-complete',
  REPORTS = 'reports',
  FAMILY_RESOURCES = 'family-resources',
}

export enum LetterBookZoom {
  DEFAULT = 1.5,
  ZOOMED = 1.25,
}

export enum AppNames {
  WDT = 'wdt',
  GSS = 'gss',
}

export enum StudentPracticeBookLevel {
  Emerging = 'Emerging',
  Developing = 'Developing',
  PreK = 'Pre-K',
}

export enum Alignment {
  FLEX_START = 'flex-start',
  FLEX_END = 'flex-end',
  CENTER = 'center',
  SPACE_BETWEEN = 'space-between',
}

export enum LetterUniCodes {
  B = '\uE000',
  G = '\uE001',
  I = '\uE002',
  J = '\uE003',
  M = '\uE004',
  Y = '\uE005',
  g = '\uE006',
  u = '\uE00A',
}
// If the j and q letter doesn't look good with Billy Bold font, use these Unicode
// j = '\uE014',
// q = '\uE015',

export enum NoOfPages {
  ONE_PAGE = 1,
  TWO_PAGES = 2,
}

export enum SupportResourceType {
  TRAINING_VIDEOS = 'trainingVideos',
  SUPPORT_DOCUMENTS = 'supportDocuments',
}

export enum Settings {
  WELCOME = 'welcome',
  FREE_TRIAL = 'freeTrial',
}

export enum PageTypes {
  Default,
  Activity,
  Pdf,
}

export const DEFAULT_FIRST_PAGE = {
  [PageTypes.Default]: 0,
  [PageTypes.Activity]: 4,
  [PageTypes.Pdf]: 1,
};

export enum PageViewType {
  OnePage = 1,
  TwoPage = 2,
}

export enum NavigationDirection {
  Next = 'Next',
  Previous = 'Previous',
}

export enum ActivityNames {
  PRACTICE_BOOK = 'Practice Book',
}

export enum ASSIGNMENT_STATUSES {
  COMPLETE = 'COMPLETED',
  INCOMPLETE = 'IN_PROGRESS',
  NEW = 'NOT_STARTED',
}
